module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-0.00a94ec4.jpg";